import axios from 'axios';
import { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';

import { MapRow, GalleryRow, ContactRow } from 'pages/MainPage.js';

import Heading from 'components/Heading.js';
import Content from 'components/Content.js';

export default function ContentPage(props) {
    const [content, setContent] = useState(null);

    let { slug } = useParams();

    useEffect(() => {
        if (slug) {
            const url = global.endpoint + 'wp-json/wp/v2/pages?slug=' + slug + '&_embed';
            axios.get(url, {}).then(function (response) {
                if (response.data)
                    setContent(response.data[0]);
            }).catch(function (error) { console.log(error); });
        }
    }, [slug]);

    return (
        <div className={'w-full flex flex-col  ' + (props.className || '')}>

            {content && <PageContent data={content} />}

            {slug === 'kapcsolat' && <>
                <ContactRow />
                <MapRow />
            </>}

            {(content && content.acf.photo_gallery && content.acf.photo_gallery.galeria[0].length > 0) && <GalleryRow data={content.acf.photo_gallery.galeria[0]} />}

        </div>
    );
}

function PageContent(props) {
    const _d = {
        slug: props.data.slug,
        title: props.data.title.rendered,
        date: props.data.date,
        content: props.data.content.rendered,
        image: (props.data._embedded && props.data._embedded['wp:featuredmedia']) && props.data._embedded['wp:featuredmedia'][0].source_url,
    }

    return (
        <div className={'w-full flex flex-col items-center bg-white ' + (props.className || '')}>

            <Heading image={_d.image} title={_d.title} />
            {_d.content && <Content data={props.data} />}

        </div>
    );
}